/* tslint:disable */
/* eslint-disable */
/**
 * Bfree API
 * API Documentation for B&Free Project
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    HouseComplete,
    HouseCompleteFromJSON,
    HouseCompleteFromJSONTyped,
    HouseCompleteToJSON,
} from './';

/**
 * 
 * @export
 * @interface HouseCompleteList
 */
export interface HouseCompleteList {
    /**
     * 
     * @type {Array<HouseComplete>}
     * @memberof HouseCompleteList
     */
    data?: Array<HouseComplete>;
}

export function HouseCompleteListFromJSON(json: any): HouseCompleteList {
    return HouseCompleteListFromJSONTyped(json, false);
}

export function HouseCompleteListFromJSONTyped(json: any, ignoreDiscriminator: boolean): HouseCompleteList {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(HouseCompleteFromJSON)),
    };
}

export function HouseCompleteListToJSON(value?: HouseCompleteList | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(HouseCompleteToJSON)),
    };
}

